import React from "react";
import T from "prop-types";
import { FormattedMessage } from "react-intl";

export function ZadostiRowPoznamka({ label, poznamka }) {
  return (
    <div className="b2b-ZadostiRowDetail-poznamka">
      <div className="b2b-ZadostiRowDetail-label b2b-ZadostiRowDetail-poznamkaLabel">
        {<FormattedMessage id={label} defaultMessage={label} />}
      </div>
      <div className="b2b-ZadostiRowDetail-poznamkaText">{poznamka}</div>
    </div>
  );
}

ZadostiRowPoznamka.propTypes = {
  label: T.string,
  poznamka: T.object
};

export default React.memo(ZadostiRowPoznamka);
